import { storageUtils } from '@/utils';
/**
 * 受保护的 storage key 列表（不会在重置时被删除）
 * 用于保存应用级配置，如：语言偏好、主题设置、记住密码等
 *
 * 注意：这些 key 可以是：
 * 1. Store 的 persist key（如 'userInfo-store'）
 * 2. 普通的 localStorage key（如 'rememberPassword'）
 */

export const STORAGE_WHITE_LIST = [
  'rememberPassword'  // 记住密码（应用级配置）

];
/**
 * 安全清空 localStorage
 * 只删除 store 相关的 key，保留白名单中的 key
 */
export function safeClearStorage() {
  const keysToDelete: string[] = [];

  // 收集需要删除的 key
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key && !STORAGE_WHITE_LIST.includes(key)) {
      keysToDelete.push(key);
    }
  }

  // 删除收集到的 key
  keysToDelete.forEach(key => {
    storageUtils.removeItem(key);
  });
}